// src/store/pos/posSyncProcessor.js



import syncQueue

  from "@/platform/storage/syncQueue";



import offlineManager

  from "@/platform/pwa/offlineManager";



import posSessionService

  from "@/modules/pos/services/posSessionService";



import posSaleService

  from "@/modules/pos/services/posSaleService";



import posSessionOfflinePersistence

  from "@/store/pos/posSessionOfflinePersistence";



import posOfflinePersistence

  from "@/store/pos/posOfflinePersistence";





// ============================================================

// SUPPORTED JOB TYPES

// ============================================================



const JOB_TYPES = {

  SESSION_OPEN:

    "POS_SESSION_OPEN",



  SALE:

    "POS_SALE",



  OFFLINE_PAYMENT:

    "POS_OFFLINE_PAYMENT",



  SESSION_CLOSE:

    "POS_SESSION_CLOSE"

};





// ============================================================

// INITIALIZATION

// ============================================================



let initialized =

  false;





// ============================================================

// REGISTER PROCESSOR

// ============================================================



function init() {

  if (

    initialized

  ) {

    return;

  }



  syncQueue.registerProcessor(

    processJob

  );



  initialized =

    true;



  console.log(

    "[POS] POS sync processor registered."

  );



  if (

    offlineManager

      .isOnlineNow()

  ) {

    syncQueue

      .process()

      .catch(

        error => {

          console.warn(

            "[POS] Initial POS queue processing failed:",

            error

          );

        }

      );

  }

}





// ============================================================

// PROCESS JOB

// ============================================================



async function processJob(

  job

) {

  if (

    !job?.type

  ) {

    throw new Error(

      "[POS] Sync job type is missing."

    );

  }



  switch (

    job.type

  ) {

    case JOB_TYPES.SESSION_OPEN:

      return processSessionOpen(

        job

      );



    case JOB_TYPES.SALE:

      return processSale(

        job

      );



    case JOB_TYPES.OFFLINE_PAYMENT:

      return processOfflinePayment(

        job

      );



    case JOB_TYPES.SESSION_CLOSE:

      return processSessionClose(

        job

      );



    default:

      throw new Error(

        `[POS] Unsupported POS sync job type: ${job.type}`

      );

  }

}





// ============================================================

// POS SESSION OPEN

// ============================================================



async function processSessionOpen(

  job

) {

  const payload =

    job?.payload

    ??

    {};



  const clientSessionId =

    payload.clientSessionId

    ??

    job?.metadata

      ?.clientSessionId

    ??

    null;



  const terminalId =

    payload.terminalId

    ??

    job?.metadata

      ?.terminalId

    ??

    null;



  if (

    !clientSessionId

  ) {

    throw new Error(

      "[POS] POS_SESSION_OPEN is missing clientSessionId."

    );

  }



  if (

    !terminalId

  ) {

    throw new Error(

      "[POS] POS_SESSION_OPEN is missing terminalId."

    );

  }



  const localSession =

    await posSessionOfflinePersistence

      .getSession(

        clientSessionId

      );



  if (

    !localSession

  ) {

    console.warn(

      "[POS] Local session no longer exists:",

      clientSessionId

    );



    return {

      alreadyResolved:

        true,



      removeFromQueue:

        true

    };

  }



  // ==========================================================

  // ALREADY SYNCHRONIZED

  // ==========================================================



  if (

    localSession

      .serverSessionId

  ) {

    await posOfflinePersistence

      .bindServerSession({

        clientSessionId,



        serverSessionId:

          localSession

            .serverSessionId

      });



    return {

      clientSessionId,



      serverSessionId:

        localSession

          .serverSessionId,



      alreadySynchronized:

        true,



      removeFromQueue:

        true

    };

  }



  await posSessionOfflinePersistence

    .markSyncing(

      localSession

    );



  try {

    const requestPayload = {

      terminalId,



      openingCashAmount:

        Number(

          payload

            .openingCashAmount

          ??

          localSession

            .openingCashAmount

          ??

          0

        ),



      currencyCode:

        normalizeCurrencyCode(

          payload.currencyCode

          ?? localSession.currencyCode

          ?? localSession.currency

          

        ),



      notes:

        payload.notes

        ??

        localSession.notes

        ??

        null

    };



    console.log(

      "[POS] Synchronizing offline session:",

      {

        clientSessionId,



        requestPayload

      }

    );



    const serverSession =

      await posSessionService

        .openSession(

          requestPayload

        );



    const serverSessionId =

      serverSession?.id

      ??

      serverSession?.sessionId

      ??

      serverSession?.serverSessionId

      ??

      null;



    if (

      !serverSessionId

    ) {

      throw new Error(

        "[POS] Backend did not return a session ID while synchronizing the offline session."

      );

    }



    offlineManager

      .reportNetworkSuccess(

        "pos-offline-session-sync-success"

      );



    const synchronizedSession =

      await posSessionOfflinePersistence

        .markSynchronized(

          localSession,

          serverSession

        );



    await posOfflinePersistence

      .bindServerSession({

        clientSessionId,



        serverSessionId

      });



    console.log(

      "[POS] Offline session synchronized:",

      {

        clientSessionId,



        serverSessionId

      }

    );



    return {

      clientSessionId,



      serverSessionId,



      session:

        synchronizedSession,



      removeFromQueue:

        true

    };

  }

  catch (error) {

    logSyncError(

      "Offline session synchronization failed",

      error,

      {

        clientSessionId,

        terminalId

      }

    );



    handleConnectivityFromError(

      error,

      "pos-offline-session-sync-network-failure",

      "pos-offline-session-sync-http-response"

    );



    await posSessionOfflinePersistence

      .markFailed(

        localSession,

        error

      );



    throw error;

  }

}





// ============================================================

// POS SALE

// ============================================================



async function processSale(

  job

) {

  const payload =

    job?.payload

    ??

    {};



  const metadata =

    job?.metadata

    ??

    {};



  const clientTransactionId =

    payload.clientTransactionId

    ??

    metadata.clientTransactionId

    ??

    null;



  const clientSessionId =

    payload.clientSessionId

    ??

    metadata.clientSessionId

    ??

    null;



  let serverSessionId =

    payload.serverSessionId

    ??

    metadata.serverSessionId

    ??

    null;



  if (

    !clientTransactionId

  ) {

    throw new Error(

      "[POS] POS_SALE is missing clientTransactionId."

    );

  }



  const localTransaction =

    await posOfflinePersistence

      .getByClientTransactionId(

        clientTransactionId

      );



  if (

    !localTransaction

  ) {

    console.log(

      "[POS] POS sale already reconciled locally:",

      clientTransactionId

    );



    return {

      clientTransactionId,



      alreadyResolved:

        true,



      removeFromQueue:

        true

    };

  }



  // ==========================================================

  // ALREADY HAS BACKEND SALE

  // ==========================================================



  if (

    localTransaction

      .saleId

  ) {

    const saleId =

      localTransaction

        .saleId;



    const resolvedServerSessionId =

      localTransaction

        .serverSessionId

      ??

      serverSessionId

      ??

      null;



    const waitingForOfflinePayment =

      isOfflinePaymentPending(

        localTransaction

      );



    console.log(

      "[POS] Offline POS sale already has backend saleId:",

      {

        clientTransactionId,



        saleId,



        serverSessionId:

          resolvedServerSessionId,



        waitingForOfflinePayment

      }

    );



    /*

    * The sale queue job has completed.

    *

    * Do NOT delete the local transaction here when an offline

    * payment still needs synchronization. The payment processor

    * needs the local transaction in order to resolve saleId.

    *

    * The queue processor may safely remove POS_SALE because

    * removeFromQueue=true.

    */

    if (

      waitingForOfflinePayment

    ) {

      return {

        clientTransactionId,



        saleId,



        serverSessionId:

          resolvedServerSessionId,



        offlineInvoiceId:

          localTransaction

            .offlineInvoiceId

          ??

          null,



        waitingForOfflinePayment:

          true,



        alreadySynchronized:

          true,



        removeFromQueue:

          true

      };

    }



    /*

    * No payment remains.

    *

    * The backend sale already exists and the local transaction

    * is no longer needed.

    */

    await posOfflinePersistence

      .deleteByKey(

        localTransaction.key

      );



    console.log(

      "[POS] Reconciled POS sale removed from local transactions:",

      {

        clientTransactionId,



        saleId

      }

    );



    return {

      clientTransactionId,



      saleId,



      serverSessionId:

        resolvedServerSessionId,



      offlineInvoiceId:

        localTransaction

          .offlineInvoiceId

        ??

        null,



      waitingForOfflinePayment:

        false,



      alreadySynchronized:

        true,



      removeFromQueue:

        true

    };

  }



  // ==========================================================

  // RESOLVE SERVER SESSION

  // ==========================================================



  if (

    !serverSessionId

    &&

    localTransaction

      .serverSessionId

  ) {

    serverSessionId =

      localTransaction

        .serverSessionId;

  }



  if (

    !serverSessionId

    &&

    clientSessionId

  ) {

    const localSession =

      await posSessionOfflinePersistence

        .getSession(

          clientSessionId

        );



    serverSessionId =

      localSession

        ?.serverSessionId

      ??

      null;

  }



  if (

    !serverSessionId

  ) {

    throw new Error(

      "[POS] POS sale synchronization is waiting for the offline session to receive a serverSessionId."

    );

  }



  await posOfflinePersistence

    .markSyncing(

      localTransaction

    );



  try {

    // ========================================================

    // USE NORMAL ONLINE SALE PIPELINE

    //

    // Backend remains responsible for:

    //

    // PosSale

    // Invoice

    // InvoiceLines

    // totals / taxes / numbering

    // ========================================================



    const salePayload = {

      ...payload,



      sessionId:

        serverSessionId,



      serverSessionId,



      clientSessionId,



      clientTransactionId,



      wasCreatedOffline:

        true,



      offlineInvoiceId:

        payload.offlineInvoiceId

        ??

        localTransaction

          .offlineInvoiceId

        ??

        null,



      clientSaleDateUtc:

        payload.clientSaleDateUtc

        ??

        localTransaction

          .createdAtUtc

        ??

        new Date()

          .toISOString()

    };



    console.log(

      "[POS] Synchronizing offline sale:",

      {

        clientTransactionId,



        clientSessionId,



        serverSessionId,



        offlineInvoiceId:

          salePayload

            .offlineInvoiceId,



        payload:

          salePayload

      }

    );



    const sale =

      await posSaleService

        .createSale(

          salePayload

        );



    const saleId =

      sale?.id

      ??

      sale?.saleId

      ??

      null;



    if (

      !saleId

    ) {

      throw new Error(

        "[POS] Backend did not return a sale ID while synchronizing the offline sale."

      );

    }



    offlineManager

      .reportNetworkSuccess(

        "pos-offline-sale-sync-success"

      );



    const synchronizedTransaction =

      await posOfflinePersistence

        .markSynchronized(

          localTransaction,

          {

            saleId,



            serverSessionId

          }

        );



    if (

      !synchronizedTransaction

    ) {

      throw new Error(

        "[POS] Local POS transaction could not be updated after backend sale synchronization."

      );

    }



    const waitingForOfflinePayment =

      isOfflinePaymentPending(

        synchronizedTransaction

      );



    if (

      waitingForOfflinePayment

    ) {

      console.log(

        "[POS] Offline sale synchronized. Local transaction retained for payment synchronization:",

        {

          clientTransactionId,



          saleId,



          offlineInvoiceId:

            synchronizedTransaction

              .offlineInvoiceId

            ??

            null

        }

      );

    }

    else {

      await posOfflinePersistence

        .deleteByKey(

          synchronizedTransaction.key

        );



      console.log(

        "[POS] Offline sale synchronized and local transaction removed:",

        {

          clientTransactionId,



          saleId

        }

      );

    }



    return {

      clientTransactionId,



      saleId,



      serverSessionId,



      offlineInvoiceId:

        synchronizedTransaction

          .offlineInvoiceId

        ??

        null,



      waitingForOfflinePayment,



      removeFromQueue:

        true

    };

  }

  catch (error) {

    logSyncError(

      "Offline sale synchronization failed",

      error,

      {

        clientTransactionId,

        clientSessionId,

        serverSessionId

      }

    );



    handleConnectivityFromError(

      error,

      "pos-offline-sale-sync-network-failure",

      "pos-offline-sale-sync-http-response"

    );



    await posOfflinePersistence

      .markFailed(

        localTransaction,

        error

      );



    throw error;

  }

}





// ============================================================

// POS OFFLINE PAYMENT

// ============================================================



async function processOfflinePayment(

  job

) {

  const payload =

    job?.payload

    ??

    {};



  const metadata =

    job?.metadata

    ??

    {};



  const clientTransactionId =

    payload.clientTransactionId

    ??

    metadata.clientTransactionId

    ??

    null;



  const offlineInvoiceId =

    payload.offlineInvoiceId

    ??

    metadata.offlineInvoiceId

    ??

    null;



  const clientSessionId =

    payload.clientSessionId

    ??

    metadata.clientSessionId

    ??

    null;



  const terminalId =

    payload.terminalId

    ??

    metadata.terminalId

    ??

    null;



  if (

    !clientTransactionId

  ) {

    throw new Error(

      "[POS] POS_OFFLINE_PAYMENT is missing clientTransactionId."

    );

  }



  if (

    !offlineInvoiceId

  ) {

    throw new Error(

      "[POS] POS_OFFLINE_PAYMENT is missing offlineInvoiceId."

    );

  }



  const localTransaction =

    await posOfflinePersistence

      .getByClientTransactionId(

        clientTransactionId

      );



  if (

    !localTransaction

  ) {

    console.log(

      "[POS] Offline payment already reconciled locally:",

      {

        clientTransactionId,



        offlineInvoiceId

      }

    );



    return {

      clientTransactionId,



      offlineInvoiceId,



      alreadyResolved:

        true,



      removeFromQueue:

        true

    };

  }



  const saleId =

    localTransaction

      .saleId

    ??

    null;



  if (

    !saleId

  ) {

    throw new Error(

      "[POS] Offline payment synchronization is waiting for POS_SALE to receive a backend saleId."

    );

  }



  const paymentMethod =

    String(

      payload.paymentMethod

      ??

      metadata.paymentMethod

      ??

      ""

    )

      .trim()

      .toLowerCase();



  if (

    paymentMethod !==

    "cash"

  ) {

    throw new Error(

      `[POS] Unsupported offline payment method: ${paymentMethod || "unknown"}`

    );

  }



  const amount =

    normalizePositiveMoney(

      payload.amount

    );



  const amountTendered =

    normalizeMoney(

      payload.amountTendered

      ??

      payload.tenderedAmount

      ??

      amount

    );



  const changeAmount =

    normalizeMoney(

      payload.changeAmount

      ??

      (

        amountTendered -

        amount

      )

    );



  if (

    amount <=

    0

  ) {

    throw new Error(

      "[POS] POS_OFFLINE_PAYMENT contains an invalid payment amount."

    );

  }



  if (

    amountTendered <

    amount

  ) {

    throw new Error(

      "[POS] POS_OFFLINE_PAYMENT amount tendered is less than the payment amount."

    );

  }



  const paidAtUtc =

    payload.paidAtUtc

    ??

    new Date()

      .toISOString();



  const currency = normalizeCurrencyCode(
    payload.currency ?? localTransaction.currency
  );



  // ==========================================================

  // EXISTING CASH ENDPOINT CONTRACT

  //

  // Important:

  // backend uses TenderedAmount, therefore JSON must send

  // tenderedAmount rather than amountTendered.

  //

  // Offline fields remain optional metadata.

  // ==========================================================



  const clientPaymentId =

    payload.clientPaymentId

    ??

    metadata.clientPaymentId

    ??

    localTransaction.clientPaymentId

    ??

    `${clientTransactionId}-cash`;



  const cashRequest = {

    clientPaymentId,



    tenderedAmount:

      amountTendered,



    offlineInvoiceId,



    clientTransactionId,



    clientSessionId,



    terminalId,



    currency,



    paidAtUtc,



    wasCreatedOffline:

      true

  };



  console.log(

    "[POS] Synchronizing offline cash payment:",

    {

      clientTransactionId,



      offlineInvoiceId,



      saleId,



      clientSessionId,



      terminalId,



      amount,



      amountTendered,



      changeAmount,



      currency,



      paidAtUtc,



      clientPaymentId:

        cashRequest.clientPaymentId

        ??

        null,



      request:

        cashRequest

    }

  );



  try {

    const payment =

      await posSaleService

        .payCash(

          saleId,

          cashRequest

        );



    offlineManager

      .reportNetworkSuccess(

        "pos-offline-cash-payment-sync-success"

      );



    const refreshedSale =

      await posSaleService

        .getSale(

          saleId

        );



    const paidAmount =

      normalizeMoney(

        refreshedSale

          ?.paidAmount

        ??

        amount

      );



    const outstandingAmount =

      normalizeMoney(

        refreshedSale

          ?.outstandingAmount

        ??

        0

      );



    console.log(

      "[POS] Offline cash payment synchronized:",

      {

        clientTransactionId,



        offlineInvoiceId,



        saleId,



        paymentTransactionId:

          payment

            ?.paymentTransactionId

          ??

          payment

            ?.id

          ??

          null,



        paidAmount,



        outstandingAmount

      }

    );



    await posOfflinePersistence

      .deleteByKey(

        localTransaction.key

      );



    console.log(

      "[POS] Fully synchronized offline transaction removed from IndexedDB:",

      {

        clientTransactionId,



        offlineInvoiceId,



        saleId

      }

    );



    return {

      clientTransactionId,



      offlineInvoiceId,



      saleId,



      clientSessionId,



      payment,



      sale:

        refreshedSale,



      paidAmount,



      outstandingAmount,



      removeFromQueue:

        true

    };

  }

  catch (error) {

    logSyncError(

      "Offline cash payment synchronization failed",

      error,

      {

        clientTransactionId,



        offlineInvoiceId,



        saleId

      }

    );



    handleConnectivityFromError(

      error,

      "pos-offline-cash-payment-sync-network-failure",

      "pos-offline-cash-payment-sync-http-response"

    );



    throw error;

  }

}





// ============================================================

// POS SESSION CLOSE

// ============================================================



async function processSessionClose(

  job

) {

  const payload =

    job?.payload

    ??

    {};



  const metadata =

    job?.metadata

    ??

    {};



  const clientSessionId =

    payload.clientSessionId

    ??

    metadata.clientSessionId

    ??

    null;



  let serverSessionId =

    payload.serverSessionId

    ??

    metadata.serverSessionId

    ??

    null;



  let localSession =

    null;



  if (

    clientSessionId

  ) {

    localSession =

      await posSessionOfflinePersistence

        .getSession(

          clientSessionId

        );



    if (

      !serverSessionId

    ) {

      serverSessionId =

        localSession

          ?.serverSessionId

        ??

        null;

    }

  }



  if (

    !serverSessionId

  ) {

    throw new Error(

      "[POS] POS_SESSION_CLOSE is waiting for the offline session to receive a serverSessionId."

    );

  }



  try {

    await posSessionService

      .closeSession(

        serverSessionId,

        {

          closingCashAmount:

            Number(

              payload

                .closingCashAmount

              ??

              localSession

                ?.closingCashAmount

              ??

              0

            ),



          notes:

            payload.notes

            ??

            localSession

              ?.closingNotes

            ??

            null

        }

      );



    offlineManager

      .reportNetworkSuccess(

        "pos-offline-session-close-sync-success"

      );



    // ==========================================================

    // REMOVE FULLY SYNCHRONIZED CLOSED LOCAL SESSION

    //

    // At this point:

    //

    // 1. The local session was opened.

    // 2. Its backend session has been resolved.

    // 3. Dependent POS sales/payments were processed before the

    //    POS_SESSION_CLOSE job.

    // 4. The backend session has now successfully closed.

    //

    // Therefore the local session reconciliation record is no

    // longer required.

    // ==========================================================



    if (

      clientSessionId

    ) {

      await posSessionOfflinePersistence

        .deleteSession(

          clientSessionId

        );



      console.log(

        "[POS] Fully synchronized closed POS session removed from IndexedDB:",

        {

          clientSessionId,



          serverSessionId

        }

      );

    }



    console.log(

      "[POS] Offline session close synchronized:",

      {

        clientSessionId,



        serverSessionId

      }

    );



    return {

      clientSessionId,



      serverSessionId,



      removeFromQueue:

        true

    };

  }

  catch (error) {

    logSyncError(

      "Offline session close synchronization failed",

      error,

      {

        clientSessionId,



        serverSessionId

      }

    );



    handleConnectivityFromError(

      error,

      "pos-offline-session-close-sync-network-failure",

      "pos-offline-session-close-sync-http-response"

    );



    throw error;

  }

}





// ============================================================

// TRUE NETWORK FAILURE

//

// IMPORTANT:

//

// error.response === undefined does NOT automatically mean that

// the network is unavailable.

//

// Local JavaScript, IndexedDB, validation and reconciliation

// errors also have no response property.

// ============================================================



function isTrueNetworkFailure(

  error

) {

  if (

    typeof navigator !==

      "undefined"

    &&

    navigator.onLine ===

      false

  ) {

    return true;

  }



  const code =

    String(

      error?.code

      ??

      ""

    )

      .trim()

      .toUpperCase();



  if (

    code ===

      "ERR_NETWORK"

    ||

    code ===

      "ECONNABORTED"

    ||

    code ===

      "ETIMEDOUT"

  ) {

    return true;

  }



  const message =

    String(

      error?.message

      ??

      ""

    )

      .trim()

      .toLowerCase();



  if (

    message ===

      "network error"

    ||

    message.includes(

      "network error"

    )

    ||

    message.includes(

      "failed to fetch"

    )

  ) {

    return true;

  }



  return false;

}





// ============================================================

// HANDLE CONNECTIVITY FROM SYNC ERROR

// ============================================================



function handleConnectivityFromError(

  error,

  networkFailureReason,

  httpResponseReason

) {

  if (

    isTrueNetworkFailure(

      error

    )

  ) {

    offlineManager

      .markOffline(

        networkFailureReason

      );



    return;

  }



  if (

    error?.response

  ) {

    /*

     * Backend returned an HTTP response.

     *

     * Even a 400 / 401 / 403 / 409 / 500 response proves that

     * network connectivity exists.

     */



    offlineManager

      .reportNetworkSuccess(

        httpResponseReason

      );

  }

}





// ============================================================

// SYNCHRONIZATION ERROR LOGGING

// ============================================================



function logSyncError(

  title,

  error,

  context =

    {}

) {

  console.error(

    `[POS] ${title}:`,

    {

      ...context,



      status:

        error?.response

          ?.status

        ??

        null,



      statusText:

        error?.response

          ?.statusText

        ??

        null,



      responseData:

        error?.response

          ?.data

        ??

        null,



      responseHeaders:

        error?.response

          ?.headers

        ??

        null,



      requestUrl:

        error?.config

          ?.url

        ??

        null,



      requestMethod:

        error?.config

          ?.method

        ??

        null,



      errorCode:

        error?.code

        ??

        null,



      message:

        error?.message

        ??

        null,



      navigatorOnline:

        typeof navigator !==

          "undefined"

          ? navigator.onLine

          : null,



      error

    }

  );

}





// ============================================================

// OFFLINE PAYMENT PENDING

// ============================================================



function isOfflinePaymentPending(

  transaction

) {

  if (

    !transaction

  ) {

    return false;

  }



  const offlineInvoiceId =

    transaction

      .offlineInvoiceId

    ??

    null;



  const status =

    String(

      transaction

        .offlineInvoiceStatus

      ??

      ""

    )

      .trim()

      .toUpperCase();



  return (

    Boolean(

      offlineInvoiceId

    )

    &&

    status ===

      "PAID"

  );

}





// ============================================================

// NORMALIZE CURRENCY

// ============================================================



function normalizeCurrencyCode(value) {

  const code = String(value )

    .trim()

    .toUpperCase();



  if (!/^[A-Z]{3}$/.test(code)) {

    throw new Error("[POS] A valid ISO currency code is required.");

  }



  return code;

}



// ============================================================

// NORMALIZE MONEY

// ============================================================



function normalizeMoney(

  value

) {

  const numeric =

    Number(

      value

      ??

      0

    );



  if (

    !Number.isFinite(

      numeric

    )

  ) {

    return 0;

  }



  return Math.round(

    (

      numeric +

      Number.EPSILON

    )

    *

    100

  )

  /

  100;

}





// ============================================================

// NORMALIZE POSITIVE MONEY

// ============================================================



function normalizePositiveMoney(

  value

) {

  const amount =

    normalizeMoney(

      value

    );



  if (

    amount <=

    0

  ) {

    return 0;

  }



  return amount;

}





// ============================================================

// EXPORT

// ============================================================



export default {

  init,



  processJob

};